import request from '@/utils/request'

export function updateLevelCfg(data) {
  return request({
    url: 'api/v1/level/updateLevelCfg',
    method: 'post',
    data: data
  })
}

export function getLevelCfgList(data) {
  return request({
    url: 'api/v1/level/getLevelCfg',
    method: 'get',
    params: data
  })
}

export function exportLevelCfg() {
  return request({
    url: 'api/v1/level/export',
    method: 'get' })
}

export function importLevelCfg(data) {
  return request({
    url: 'api/v1/level/import',
    method: 'post',
    data: data
  })
}

